import { FadeUp, MaskedLine, Overline } from "./Reveal";
import { IMG } from "../data/content";

export const PageHero = ({ overline, lines, desc, img, imgAlt, accent = "#D97706", children }) => (
  <section className="hospitality-background relative pt-28 sm:pt-32 lg:pt-40 pb-20 overflow-hidden grain-overlay">
    <div className="absolute top-20 -left-32 w-96 h-96 rounded-full bg-saffron-soft blur-3xl opacity-70 drift-c" />
    <div className="absolute bottom-0 right-0 w-80 h-80 rounded-full bg-terracotta-soft blur-3xl opacity-80 drift-b" />
    <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-14 relative grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
      <div>
        <FadeUp y={16}>
          <Overline>{overline}</Overline>
        </FadeUp>
        <h1 className="mt-5 font-display font-extrabold tracking-tight leading-[1.08] text-4xl sm:text-5xl lg:text-6xl text-aubergine">
          {lines.map((line, i) => (
            <MaskedLine key={i} delay={0.08 * i + 0.1}>
              {i === lines.length - 1 ? <span style={{ color: accent }}>{line}</span> : line}
            </MaskedLine>
          ))}
        </h1>
        {desc && (
          <FadeUp delay={0.35}>
            <p className="mt-6 text-base sm:text-lg leading-relaxed text-ink-muted max-w-xl">{desc}</p>
          </FadeUp>
        )}
        {children && <FadeUp delay={0.45}>{children}</FadeUp>}
      </div>
      {img && (
        <FadeUp delay={0.25} className="relative">
          <div className="absolute -inset-4 rounded-[2.5rem] border border-dashed rotate-2" style={{ borderColor: accent }} />
          <div className="relative rounded-[2.5rem] overflow-hidden shadow-[0_32px_80px_rgba(45,18,77,0.18)] aspect-[4/3]">
            <img src={img} alt={imgAlt || overline} className="w-full h-full object-cover" loading="eager" />
            <div className="absolute inset-0 bg-gradient-to-t from-aubergine-deep/30 to-transparent" />
          </div>
        </FadeUp>
      )}
    </div>
  </section>
);

export const CTASection = ({ title, sub }) => (
  <section className="relative py-14 sm:py-20 overflow-hidden">
    <img src="/photo-marketing.jpg" alt="" aria-hidden className="absolute inset-0 w-full h-full object-cover" />
    <div className="absolute inset-0 bg-aubergine/95" />
    <div className="absolute -top-24 left-1/4 w-96 h-96 rounded-full bg-aubergine-light/50 blur-3xl" />
    <div className="absolute -bottom-32 right-10 w-96 h-96 rounded-full bg-saffron/20 blur-3xl" />
    <div className="absolute inset-0 grain-overlay opacity-60" />
    <div className="max-w-5xl mx-auto px-5 sm:px-8 text-center relative">
      <FadeUp>
        <span className="font-mono uppercase text-xs tracking-[0.22em] text-saffron-warm">Ready when you are</span>
        <h2 className="mt-4 font-display font-extrabold text-3xl sm:text-5xl text-cream tracking-tight leading-tight">{title}</h2>
        {sub && <p className="mt-5 text-cream/70 max-w-2xl mx-auto text-base sm:text-lg leading-relaxed">{sub}</p>}
        <div className="mt-9 flex flex-wrap justify-center gap-4">
          <a
            href="/contact"
            data-testid="cta-consultation-button"
            className="inline-flex items-center gap-2 bg-saffron text-aubergine-deep font-bold px-7 py-3.5 rounded-full hover:bg-cream transition-colors duration-300"
          >
            Get Free Consultation
          </a>
          <a
            href="https://wa.me/918105032380"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-whatsapp-button"
            className="inline-flex items-center gap-2 border border-cream/30 text-cream font-bold px-7 py-3.5 rounded-full hover:bg-cream hover:text-aubergine transition-colors duration-300"
          >
            Chat on WhatsApp
          </a>
        </div>
      </FadeUp>
    </div>
  </section>
);
